module.exports = __webpack_public_path__ + "img/lacrosse-stick.2b6eb0c0.svg";